import { Lock } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import MainLayout from "@/components/layouts";

export default function SuspendedPage() {
    const breadcrumb = [
        { name: "Suspended", href: "#" }
    ];

    return (
        <MainLayout breadcrumb={breadcrumb} rightSidebar={false}>
            <Card className="max-w-md mx-auto mt-32 text-center">
                <CardHeader>
                    <Lock className="mx-auto mb-2 h-12 w-12 text-red-500" />
                    <CardTitle>Account Suspended</CardTitle>
                </CardHeader>
                <CardContent>
                    <p className="text-muted-foreground mb-4">
                        Your access to this organization has been suspended.
                        Please contact your administrator for assistance.
                    </p>
                </CardContent>
            </Card>
        </MainLayout>
    );
}